/**
 * The query of a project page: the run whose dashboard is open, when a link names one, and
 * `from: 'dashboard'` when the report was opened from the Code Quality overview in Dashboards.
 */
export interface ProjectSearch {
  run?: string;
  from?: 'dashboard';
}

/** Reads the project page query, keeping only a run id that is non-empty text and a known origin. */
export function parseProjectSearch(
  search: Record<string, unknown>,
): ProjectSearch {
  const run = search.run;
  return {
    ...(typeof run === 'string' && run.length > 0 ? { run } : {}),
    ...(search.from === 'dashboard' ? { from: 'dashboard' as const } : {}),
  };
}
